import { render } from "./getInTouch.vue?vue&type=template&id=0f41d011"
import script from "./getInTouch.vue?vue&type=script&lang=js"
export * from "./getInTouch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__